export const TASK_FORM_LABELS = {
  // Navigation / page title
  NAV_TITLE: 'Formularze zadań',
  PAGE_TITLE: 'Formularze zadań',

  // List page — empty state
  EMPTY_STATE_TITLE: 'Brak dostępnych formularzy.',
  EMPTY_STATE_DESCRIPTION: 'Twórz formularze i zarządzaj nimi dla różnych ról.',

  // Buttons
  BUTTON_CREATE: 'Utwórz formularz zadania',
  BUTTON_CANCEL: 'Anuluj',
  BUTTON_PREVIEW: 'Podgląd',
  BUTTON_SAVE: 'Zapisz formularz',
  BUTTON_SAVING: 'Zapisywanie...',
  BUTTON_BACK_TO_EDIT: 'Wróć do edycji',
  BUTTON_ADD_SECTION: 'Dodaj sekcję',
  BUTTON_ADD_FIELD: 'Dodaj pole',
  BUTTON_CLOSE_PREVIEW: 'Zamknij podgląd',

  // Create page — header
  CREATE_TITLE: 'Utwórz formularz zadania',
  BREADCRUMB_LIST: 'Formularze zadań',
  BREADCRUMB_CREATE: 'Utwórz formularz zadania',

  ALERT_TEXT:
    'Ten formularz będzie używany przez techników do rejestrowania szczegółów zadań serwisowych podczas realizacji zgłoszeń. Skonfiguruj pola wymagane do wykonania zadania.',

  // Form details section
  SECTION_FORM_DETAILS: 'Szczegóły formularza',
  FORM_DETAILS_DESC:
    'Podaj podstawowe informacje identyfikacyjne i kontekst, aby pomóc technikom rozpoznać i zrozumieć przeznaczenie tego formularza.',
  FIELD_FORM_NAME: 'Nazwa formularza',
  FIELD_FORM_DESCRIPTION: 'Opis',

  // Sections
  SECTION_SECTIONS: 'Sekcje',
  SECTIONS_DESC:
    'Twórz logiczne grupy pól, aby uporządkować informacje i ułatwić technikom poruszanie się po długich formularzach.',
  SECTION_NAME_PLACEHOLDER: 'Nazwa sekcji',
  SECTION_DESC_PLACEHOLDER: 'Opis (Opcjonalne)',

  // Fields inside a section
  FIELDS_SECTION_TITLE: 'Pola formularza',
  FIELDS_SECTION_DESC:
    'Określ informacje, które technicy muszą podać, aby prawidłowo udokumentować i zrealizować zgłoszenie serwisowe.',
  FIELD_LABEL_PLACEHOLDER: 'Etykieta pola',
  FIELD_TYPE_LABEL: 'Typ pola',
  FIELD_OPTIONAL: 'Opcjonalne',
  FIELDS_REQUIRED_NOTE:
    'Wszystkie pola są domyślnie wymagane. Zaznacz „Opcjonalne" tylko wtedy, gdy Technik może pominąć to pole.',

  // Options (dropdown / radio / checkbox)
  OPTIONS_LABEL: 'Opcje',
  OPTIONS_DESC:
    'Kliknij ostatnią dostępną opcję, aby automatycznie dodać nowy wybór do listy.',
  MULTI_SELECT: 'Wielokrotny wybór',

  // Number range
  NUMBER_RANGE_SECTION: 'Liczba z zakresem',
  NUMBER_RANGE_ALERT:
    'Określ zakres prawidłowy dla tego odczytu. Wartości poniżej minimum zostaną oznaczone jako Niskie, a wartości powyżej maksimum jako Wysokie.',
  NUMBER_RANGE_TOOL_TIP_INFO:
    'Profile image requirements\nPNG, JPG, or JPEG format\nMaximum file size: 5 MB',
  MIN_VALUE: 'Wartość minimalna',
  MAX_VALUE: 'Wartość maksymalna',
  TO_LABEL: 'do',
  UNIT_LABEL: 'Jedn.',

  // Attachment
  ATTACHMENT_CONFIG_LABEL: 'Konfiguracja plików',
  ATTACHMENT_CONFIG_DESC:
    'Skonfiguruj dozwolone typy plików, limity rozmiaru i maksymalną liczbę przesyłanych plików.',
  ACCEPTED_FILE_TYPES: 'Dozwolone formaty plików',
  MAX_FILE_SIZE: 'Maks. rozmiar pliku (MB)',
  MAX_FILES: 'Maks. liczba przesyłanych plików',

  // Signature section
  SIGNATURE_SECTION: 'Podpis',
  SIGNATURE_DESC:
    'Dodaj pole podpisu, aby uzyskać potwierdzenie technika w momencie przesyłania formularza.',
  SIGNATURE_REQUIRED: 'Wymagane',

  // Field types display names
  FIELD_TYPE_TEXT: 'Tekst (jednowierszowy) (100 znaków)',
  FIELD_TYPE_TEXTAREA: 'Tekst (wielowierszowy) (500 znaków)',
  FIELD_TYPE_NUMBER: 'Liczba',
  FIELD_TYPE_NUMBER_RANGE: 'Liczba z zakresem',
  FIELD_TYPE_DATE: 'Data',
  FIELD_TYPE_DATE_RANGE: 'Zakres dat',
  FIELD_TYPE_DROPDOWN: 'Lista rozwijana',
  FIELD_TYPE_RADIO: 'Przycisk jednokrotnego wyboru',
  FIELD_TYPE_CHECKBOX: 'Pole wyboru',
  FIELD_TYPE_ATTACHMENT: 'Załącznik',
  FIELD_TYPE_PRICE: 'Cena',

  // List page
  LIST_SEARCH_PLACEHOLDER: 'Szukaj po nazwie lub ID',
  LIST_COL_NAME: 'Nazwa',
  LIST_COL_ID: 'ID formularza',
  LIST_COL_DESC: 'Opis',
  LIST_COL_DATE: 'Data utworzenia',
  LIST_COL_ACTIONS: 'Akcje',
  LIST_ACTION_VIEW: 'Podgląd',
  LIST_ACTION_EDIT: 'Edytuj',
  LIST_NO_DATA_TITLE: 'Brak dostępnych formularzy.',
  LIST_NO_DATA_DESC: 'Twórz formularze i zarządzaj nimi dla różnych ról.',
  LIST_NO_RESULTS_TITLE: 'Brak wyników.',
  LIST_NO_RESULTS_DESC: 'Spróbuj zmienić kryteria wyszukiwania.',

  // Success / error feedback
  CREATE_SUCCESS: 'Formularz zadania został pomyślnie utworzony.',

  // Validation errors
  ERROR_FORM_NAME_REQUIRED: 'To pole jest wymagane.',
  ERROR_FORM_NAME_MAX: 'Nazwa formularza może mieć maksymalnie 200 znaków.',
  ERROR_FORM_DESCRIPTION_REQUIRED: 'To pole jest wymagane.',
  ERROR_DESCRIPTION_MAX: 'Opis może mieć maksymalnie 500 znaków.',
  ERROR_SECTION_NAME_REQUIRED: 'To pole jest wymagane.',
  ERROR_SECTION_DESC_REQUIRED: 'To pole jest wymagane.',
  ERROR_SECTION_MIN_FIELDS: 'To pole jest wymagane.',
  ERROR_FIELD_LABEL_REQUIRED: 'To pole jest wymagane.',
  ERROR_FIELD_LABEL_MAX: 'Etykieta pola może mieć maksymalnie 30 znaków.',
  ERROR_FIELD_TYPE_REQUIRED: 'To pole jest wymagane.',
  ERROR_RANGE_MAX_GT_MIN: 'Maximum value must be greater than minimum value.',
  ERROR_FIELD_MIN_OPTIONS: 'To pole jest wymagane.',
  ERROR_OPTION_LABEL_REQUIRED: 'To pole jest wymagane.',
  ERROR_MAX_SECTIONS: 'Formularz może zawierać maksymalnie 10 sekcji.',
  ERROR_MAX_FIELDS: 'Sekcja może zawierać maksymalnie 10 pól.',
  ERROR_MAX_OPTIONS: 'Lista może zawierać maksymalnie 10 opcji.',
  ERROR_OPTION_MAX: 'Opcja może mieć maksymalnie 200 znaków.',
  ERROR_UNIT_MAX: 'Jednostka może mieć maksymalnie 10 znaków.',
  ERROR_NO_SECTIONS: 'Formularz musi zawierać co najmniej jedną sekcję.',

  // Tooltips
  TOOLTIP_REORDER_SECTION: 'Zmień kolejność sekcji',
  TOOLTIP_REORDER_FIELD: 'Zmień kolejność pól',
  TOOLTIP_REORDER_OPTION: 'Zmień kolejność opcji',
  TOOLTIP_DELETE_SECTION: 'Usuń sekcję',
  TOOLTIP_DELETE_FIELD: 'Usuń pole',
  TOOLTIP_DELETE_OPTION: 'Usuń opcję',
  TOOLTIP_MAX_SECTIONS: 'Maximum of 10 sections can be added',
  TOOLTIP_MAX_FIELDS: 'Maximum of 10 form fields can be added per section',

  // Cancel modal
  CANCEL_MODAL_TITLE: 'Czy na pewno chcesz anulować?',
  CANCEL_MODAL_DESC: 'Wszystkie niezapisane dane zostaną utracone.',
  CANCEL_MODAL_CONFIRM: 'Tak, anuluj',
  CANCEL_MODAL_BACK: 'Wróć',

  // Preview
  PREVIEW_TITLE: 'Podgląd formularza',
  PREVIEW_NOTE:
    'Tak formularz zobaczy Technik. Możesz korzystać z pól, aby przetestować działanie — wprowadzone dane nie zostaną zapisane.',

  // Edit form page
  EDIT_TITLE: 'Edytuj formularz zadania',
  EDIT_SUCCESS: 'Formularz zadania został pomyślnie zaktualizowany.',
  EDIT_ERROR_GENERIC: 'Nie udało się załadować formularza. Spróbuj ponownie.',

  // View form page
  VIEW_PAGE_TITLE: 'Podgląd formularza zadania',
  VIEW_BREADCRUMB: 'Podgląd formularza zadania',
  BUTTON_EDIT_FORM: 'Edit Task Form',
  VIEW_TAB_DETAILS: 'Szczegóły formularza',
  VIEW_TAB_TECHNICIANS: 'Assigned Technicians',
  VIEW_LABEL_FORM_ID: 'ID formularza',
  VIEW_LABEL_FORM_NAME: 'Nazwa formularza',
  VIEW_LABEL_DESCRIPTION: 'Opis',
  VIEW_LABEL_CREATED_AT: 'Data utworzenia',
  VIEW_ERROR_NOT_FOUND: 'Nie znaleziono formularza.',
  VIEW_ERROR_GENERIC: 'Nie udało się załadować formularza. Spróbuj ponownie.',
  VIEW_TECHNICIANS_PLACEHOLDER: 'Brak przypisanych techników.',
} as const;

/**
 * UI strings for the task form fill flow (technician wizard).
 * Covers the 3-step stepper, discard dialog, submitted state, and error messages.
 */
export const FILL_TASK_FORM_LABELS = {
  // Page
  PAGE_TITLE: 'Wypełnij formularz zadania',

  // Stepper step labels
  STEP_1_LABEL: 'Szczegóły',
  STEP_2_LABEL: 'Raport z zadania',
  STEP_3_LABEL: 'Podgląd i wysłanie',

  // Step 1 — section headings
  STEP1_SECTION_BASIC: 'Podstawowe dane',
  STEP1_SECTION_CLIENT: 'Dane klienta',
  STEP1_SECTION_FACILITY: 'Dane placówki',
  STEP1_SECTION_ADDRESS: 'Dane adresowe',

  // Step 1 — field labels
  LABEL_FORM_ID: 'ID formularza',
  LABEL_SR_ID: 'ID zgłoszenia serwisowego',
  LABEL_TECHNICIAN_ID: 'ID technika',
  LABEL_TECHNICIAN_NAME: 'Imię i nazwisko technika',
  LABEL_DATE_OF_SERVICE: 'Data usługi',
  LABEL_CLIENT_ID: 'ID klienta',
  LABEL_CLIENT_NAME: 'Nazwa klienta',
  LABEL_CLIENT_PHONE: 'Numer telefonu',
  LABEL_CLIENT_EMAIL: 'Adres e-mail',
  LABEL_FACILITY_ID: 'ID placówki',
  LABEL_FACILITY_NAME: 'Nazwa placówki',
  LABEL_ADDRESS_LINE1: 'Adres (linia 1)',
  LABEL_ADDRESS_LINE2: 'Adres (linia 2)',
  LABEL_CITY: 'Miejscowość',
  LABEL_STATE: 'Województwo',
  LABEL_POSTAL_CODE: 'Kod pocztowy',
  LABEL_COUNTRY: 'Kraj',

  // Step 1 — equipment section
  STEP1_SECTION_EQUIPMENT: 'Dane aparatury',
  LABEL_EQUIPMENT_NAME: 'Nazwa aparatury',
  LABEL_EQUIPMENT_ID_DISPLAY: 'Equipment ID',
  LABEL_EQUIPMENT_CATEGORY: 'Kategoria',
  LABEL_EQUIPMENT_MODEL: 'Nazwa modelu',
  LABEL_EQUIPMENT_SERIAL: 'Numer seryjny',
  LABEL_EQUIPMENT_MANUFACTURE_DATE: 'Data produkcji',
  EQUIPMENT_LOADING: 'Ładowanie listy urządzeń…',
  EQUIPMENT_LOAD_ERROR: 'Nie udało się załadować listy urządzeń.',
  EQUIPMENT_NO_RESULTS: 'Brak urządzeń do wyświetlenia.',

  // Legacy field labels (kept for SubmittedView)
  LABEL_CLIENT: 'Klient',
  LABEL_EQUIPMENT: 'Urządzenie',
  LABEL_TECHNICIAN: 'Technik',
  LABEL_SCHEDULED: 'Zaplanowany termin',
  LABEL_FORM_NAME: 'Nazwa formularza',
  VALUE_NOT_ASSIGNED: '—',

  // Step 2 — form fields
  STEP2_TITLE: 'Raport z zadania',
  STEP2_DESC: '',

  // Step 3 — preview
  STEP3_TITLE: 'Podgląd i wysłanie',
  STEP3_DESC: 'Sprawdź dane przed wysłaniem formularza.',
  STEP3_SR_SECTION_TITLE: 'Podstawowe dane',
  STEP3_FORM_SECTION_TITLE: 'Odpowiedzi w formularzu',
  STEP3_FIELD_EMPTY: '—',

  // Buttons
  BUTTON_CANCEL: 'Anuluj',
  BUTTON_NEXT: 'Dalej',
  BUTTON_PREVIEW: 'Podgląd',
  BUTTON_PREVIEWING: 'Podgląd…',
  BUTTON_BACK: 'Wstecz',
  BUTTON_SUBMIT: 'Wyślij',
  BUTTON_SUBMITTING: 'Wysyłanie…',
  BUTTON_BACK_TO_SR: 'Wróć do zgłoszenia',

  // Discard dialog
  DISCARD_TITLE: 'Odrzucić zmiany?',
  DISCARD_DESC:
    'Wprowadzone zmiany nie zostaną zapisane. Czy na pewno chcesz anulować?',
  DISCARD_CANCEL: 'Kontynuuj edycję',
  DISCARD_CONFIRM: 'Odrzuć zmiany',

  // Submitted state
  SUBMITTED_TITLE: 'Formularz przesłany',
  SUBMITTED_DESC:
    'Formularz zadania został pomyślnie przesłany. Zgłoszenie serwisowe zostało oznaczone jako zakończone.',
  SUBMITTED_AT_LABEL: 'Data przesłania',
  SUBMITTED_SECTION_TITLE: 'Wypełnione odpowiedzi',

  // Success snackbar
  SUBMIT_SUCCESS: 'Formularz zadania został pomyślnie przesłany.',

  // Signature sections
  SECTION_CLIENT_SIGNATURE: 'Podpis klienta',
  CLIENT_SIGNATURE_PLACEHOLDER: 'Złóż podpis tutaj',
  CLIENT_SIGNATURE_CLEAR: 'Wyczyść',
  CLIENT_SIGNATURE_HELPER:
    'Użyj rysika lub dotyku ekranu, aby pobrać podpis cyfrowy klienta bezpośrednio na urządzeniu.',
  SECTION_TECH_SIGNATURE: 'Podpis technika',
  TECH_SIGNATURE_REPLACE: 'Zastąp',
  SECTION_NOTES: 'Dodaj notatki',
  NOTES_LABEL: 'Notatka technika',

  // Error messages
  ERROR_LOAD_GENERIC: 'Nie udało się załadować formularza. Spróbuj ponownie.',
  ERROR_NO_SCHEMA: 'Do tego zgłoszenia nie przypisano formularza zadania.',
  ERROR_SUBMIT_GENERIC: 'Nie udało się przesłać formularza. Spróbuj ponownie.',
  ERROR_SUBMIT_FORBIDDEN: 'Nie masz uprawnień do wykonania tej akcji.',
  ERROR_FIELD_REQUIRED: 'To pole jest wymagane.',
  ERROR_FIELD_MAX_LENGTH: 'Przekroczono maksymalną liczbę znaków ({max}).',
  ERROR_FIELD_MIN_VALUE: 'Wartość minimalna wynosi {min}.',
  ERROR_FIELD_MAX_VALUE: 'Wartość maksymalna wynosi {max}.',
  ERROR_DATE_RANGE_START: 'Wybierz datę początkową.',
  ERROR_DATE_RANGE_END: 'Wybierz datę końcową.',
  ERROR_EQUIPMENT_REQUIRED: 'To pole jest wymagane.',
  ERROR_CLIENT_SIGNATURE_REQUIRED: 'Podpis klienta jest wymagany.',
  ERROR_TECH_SIGNATURE_REQUIRED: 'Podpis technika jest wymagany.',
  ERROR_SIGNATURE_UPLOAD_FAILED:
    'Nie udało się przesłać podpisu. Spróbuj ponownie.',
} as const;

export const FIELD_TYPE_OPTIONS = [
  { value: 'text', label: TASK_FORM_LABELS.FIELD_TYPE_TEXT },
  { value: 'textarea', label: TASK_FORM_LABELS.FIELD_TYPE_TEXTAREA },
  { value: 'number', label: TASK_FORM_LABELS.FIELD_TYPE_NUMBER },
  { value: 'number_range', label: TASK_FORM_LABELS.FIELD_TYPE_NUMBER_RANGE },
  { value: 'date', label: TASK_FORM_LABELS.FIELD_TYPE_DATE },
  { value: 'date_range', label: TASK_FORM_LABELS.FIELD_TYPE_DATE_RANGE },
  { value: 'price', label: TASK_FORM_LABELS.FIELD_TYPE_PRICE },
  { value: 'dropdown', label: TASK_FORM_LABELS.FIELD_TYPE_DROPDOWN },
  { value: 'radio', label: TASK_FORM_LABELS.FIELD_TYPE_RADIO },
  { value: 'checkbox', label: TASK_FORM_LABELS.FIELD_TYPE_CHECKBOX },
  { value: 'attachment', label: TASK_FORM_LABELS.FIELD_TYPE_ATTACHMENT },
] as const;

export const ACCEPTED_FILE_TYPE_OPTIONS = [
  'PDF',
  'JPG',
  'JPEG',
  'PNG',
  'DOC',
  'DOCX',
  'XLS',
  'XLSX',
  'CSV',
  'TXT',
] as const;

export const SUBMITTED_FORM_LABELS = {
  LIST_TITLE: 'Przesłane formularze',
  SEARCH_PLACEHOLDER: 'Szukaj po nazwie formularza',
  FILTER_BUTTON: 'Filtruj',

  CARD_TASK_ID: 'ID zadania',
  CARD_FORM_ID: 'ID formularza',
  CARD_SUBMISSION_DATE: 'Data przesłania',

  ACTION_VIEW: 'Podgląd',

  EMPTY_TITLE: 'Nie przesłano jeszcze żadnych formularzy.',
  EMPTY_SUBTITLE: 'Przesłane formularze pojawią się tutaj.',

  NO_RESULTS_TITLE: 'Brak wyników.',
  NO_RESULTS_SEARCH_AND_FILTER:
    'Spróbuj zmienić kryteria wyszukiwania lub filtry, aby znaleźć to, czego szukasz.',
  NO_RESULTS_SEARCH_ONLY:
    'Spróbuj zmienić kryteria wyszukiwania, aby znaleźć to, czego szukasz.',
  NO_RESULTS_FILTER_ONLY:
    'Spróbuj zmienić filtry, aby znaleźć to, czego szukasz.',

  FETCH_ERROR:
    'Nie udało się załadować przesłanych formularzy. Spróbuj ponownie.',
} as const;

export const MAX_SECTIONS = 10;
export const MAX_FIELDS = 10;
export const MAX_OPTIONS = 10;
export const MAX_FILE_SIZE_MB = 5;
export const MAX_FILES = 5;

export const VIEW_SUBMITTED_FORM_LABELS = {
  PAGE_TITLE: 'Podgląd przesłanego formularza',

  TAB_BASIC_DETAILS: 'Podstawowe dane',
  TAB_TASK_REPORT: 'Raport z zadania',

  // Basic Details tab — section headings
  SECTION_BASIC_DETAILS: 'Podstawowe dane',
  SECTION_CLIENT: 'Dane klienta',
  SECTION_FACILITY: 'Dane placówki',
  SECTION_LOCATION: 'Dane adresowe',
  SECTION_EQUIPMENT: 'Dane aparatury',

  // Basic Details fields
  FIELD_FORM_NAME: 'Nazwa formularza',
  FIELD_FORM_ID: 'ID formularza',
  FIELD_SR_ID: 'ID zgłoszenia serwisowego',
  FIELD_TECHNICIAN_ID: 'ID technika',
  FIELD_TECHNICIAN_NAME: 'Imię i nazwisko technika',
  FIELD_DATE_OF_SERVICE: 'Data usługi',
  FIELD_STATUS: 'Status',

  // Client fields
  FIELD_CLIENT_ID: 'ID klienta',
  FIELD_CLIENT_NAME: 'Nazwa klienta',
  FIELD_CLIENT_EMAIL: 'Adres e-mail',
  FIELD_CLIENT_PHONE: 'Numer telefonu',

  // Facility fields
  FIELD_FACILITY_ID: 'ID placówki',
  FIELD_FACILITY_NAME: 'Nazwa placówki',

  // Location fields
  FIELD_ADDRESS_LINE1: 'Adres (linia 1)',
  FIELD_ADDRESS_LINE2: 'Adres (linia 2)',
  FIELD_CITY: 'Miejscowość',
  FIELD_STATE: 'Województwo',
  FIELD_POSTAL: 'Kod pocztowy',
  FIELD_COUNTRY: 'Kraj',

  // Equipment fields
  FIELD_EQUIPMENT_NAME: 'Nazwa aparatury',
  FIELD_EQUIPMENT_ID: 'ID aparatury',
  FIELD_SERIAL_NUMBER: 'Numer seryjny',
  FIELD_MODEL_NUMBER: 'Nazwa modelu',
  FIELD_EQUIPMENT_DATE_OF_SERVICE: 'Data usługi',
  FIELD_EQUIPMENT_CATEGORY: 'Kategoria',

  // Task Report tab
  SECTION_CLIENT_SIGNATURE: 'Podpis klienta',
  SECTION_TECH_SIGNATURE: 'Podpis technika',
  SECTION_NOTES: 'Dodaj notatki',
  FIELD_TECH_NOTE: 'Notatka technika',
  EMPTY_VALUE: '—',

  // Loading / error
  LOADING_ERROR:
    'Nie udało się załadować szczegółów formularza. Spróbuj ponownie.',
} as const;
